// designationService.js
import apiInstance from 'services/ApiService';
import { ApiConfig } from 'config/ApiConfig';
import { CRUD_ENTITIES } from '../utils/entitiesCrud';
import { appendToastStatus } from 'utils/utils';
import { STATE_ENTITIES } from 'utils/entities';





export const createVenue = async (data) => {
  const { url, method ,toastStatus } = ApiConfig.VENUE.CREATE;
  data.append('toastStatus', toastStatus);


  const response = await apiInstance({ url, method, data :data});
  return { response, entity: CRUD_ENTITIES.VENUE.namespace };
};

export const updateVenue = async (data , {id}) => {
  const { url, method ,toastStatus } = ApiConfig.VENUE.UPDATE;
  const updateUrl = url.replace(':id',id); // Use id in URL
  data.append('toastStatus', toastStatus);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data
  });
  return { response, entity: CRUD_ENTITIES.VENUE.namespace};
};


export const deleteVenue = async (id) => {
  const { url, method, toastStatus } = ApiConfig.VENUE.DELETE;
  const deleteUrl = url.replace(':id', id); // Use id in URL
  const requestData = appendToastStatus({}, toastStatus);
  const response = await apiInstance({
    url: deleteUrl, 
    method,
    data: requestData
  });
  
  return { response, entity: CRUD_ENTITIES.VENUE.namespace };
};



export const readVenue = async (params) => {
  const { url, method } = ApiConfig.VENUE.LIST;
  const data = {apiLoading : true}
  const response = await apiInstance({ url, method,params ,data});
  return { response, entity: CRUD_ENTITIES.VENUE.namespace };
};


export const readOneVenue = async (params , id  ) => {
  const { url, method ,toastStatus } = ApiConfig.VENUE.DETAIL;
  const getUrl = url.replace(':id', id); // Use id in URL
  const requestData = appendToastStatus({}, toastStatus);
  const response = await apiInstance({
    url :getUrl, 
    method, 
    params ,
    data : requestData
  });
  
  return { response, entity: CRUD_ENTITIES.VENUE.namespace };
};


export const updateVenueStatus = async (data , {id}) => {
  const { url, method ,toastStatus ,loading } = ApiConfig.VENUE.CHANGE_STATUS;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: CRUD_ENTITIES.VENUE.namespace ,loading};
};



export const venueOnboarding = async (data) => {
  const { url, method } = ApiConfig.VENUE.ONBOARDING;
  const response = await apiInstance({ url, method ,data });
  return { response, entity: STATE_ENTITIES.VENUE.ONBOARDING };
};



export const venueTopLocations = async (params) => {
  const { url, method ,apiLoading} = ApiConfig.VENUE.TOP_LOCATIONS;
  const data = {apiLoading : apiLoading}

  const response = await apiInstance({ url, method ,params ,data});
  return { response, entity: STATE_ENTITIES.VENUE.TOP_LOCATIONS };
};


export const venueTopCategories = async (params) => {
  const { url, method ,apiLoading} = ApiConfig.VENUE.TOP_CATEGORIES;
  const data = {apiLoading : apiLoading}

  const response = await apiInstance({ url, method ,params ,data});
  return { response, entity: STATE_ENTITIES.VENUE.TOP_CATEGORIES };
};





export const venueList = async (params) => {
  const { url, method } = ApiConfig.VENUE.LIST;
  const response = await apiInstance({ url, method ,params });
  return { response, entity: STATE_ENTITIES.VENUE.LIST };
};

export const venueDeatil = async (id) => {
  const { url, method ,toastStatus } =ApiConfig.VENUE.DETAIL;
  const getUrl = url.replace(':id', id); // Use id in URL
  const requestData = appendToastStatus({}, toastStatus);
  const response = await apiInstance({
    url :getUrl, 
    method, 
    data : requestData
  });
  return { response, entity: STATE_ENTITIES.VENUE.DETAIL}
};

export const venueFilters = async (params) => {
  const { url, method } = ApiConfig.VENUE.FILTER;
  const response = await apiInstance({ url, method ,params });
  return { response, entity: STATE_ENTITIES.VENUE.FILTER };
};








export const writeReview = async (data , {id}) => {
  const { url, method ,toastStatus ,apiLoading } = ApiConfig.VENUE.WRITE_REVIEW;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus,apiLoading);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: STATE_ENTITIES.VENUE.WRITE_REVIEW };
};

export const requestPriceEstimate = async (data , {id}) => {
  const { url, method ,toastStatus ,apiLoading } = ApiConfig.VENUE.REQUEST_PRICE_ESTIMATE;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus,apiLoading);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: STATE_ENTITIES.VENUE.WRITE_REVIEW };
};


export const createVenueReview = async (data) => {
  const { url, method ,toastStatus } = ApiConfig.VENUE_REVIEW.CREATE;
  data.toastStatus = toastStatus


  const response = await apiInstance({ url, method, data :data});
  return { response, entity: CRUD_ENTITIES.VENUE_REVIEW.namespace };
};


export const readVenueReview = async (params) => {
  const { url, method } = ApiConfig.VENUE_REVIEW.READ;
  const data = {}
  const response = await apiInstance({ url, method,params ,data});
  return { response, entity: CRUD_ENTITIES.VENUE_REVIEW.namespace };
};



export const readVenueRecommend = async (params) => {
  const { url, method } = ApiConfig.VENUE_RECOMMEND.LIST;
  const data = {apiLoading : true}
  const response = await apiInstance({ url, method,params ,data});
  return { response, entity: CRUD_ENTITIES.VENUE_RECOMMEND.namespace };
};


export const updateVenueRecommendFavoriteStatus = async (data , {id}) => {
  const { url, method ,toastStatus ,apiLoading } = ApiConfig.VENUE_RECOMMEND.CHANGE_FAVORITE_STATUS;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus,apiLoading);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: CRUD_ENTITIES.VENUE_RECOMMEND.namespace ,loading : false};
};



export const updateVenueFavoriteStatus = async (data , {id}) => {
  const { url, method ,toastStatus ,apiLoading } = ApiConfig.VENUE.CHANGE_FAVORITE_STATUS;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus,apiLoading);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: CRUD_ENTITIES.VENUE.namespace ,loading : false};
};

export const updateVenueFavoriteRecommendStatus = async (data , {id}) => {
  const { url, method ,toastStatus ,apiLoading } = ApiConfig.VENUE.CHANGE_FAVORITE_STATUS;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus,apiLoading);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: STATE_ENTITIES.VENUE.MAKE_FAVORITE };

};






export const venueSearchByName = async (params) => {
  const { url, method } = ApiConfig.VENUE.SEARCH_BY_NAME;
  const response = await apiInstance({ url, method ,params });
  return { response, entity: STATE_ENTITIES.VENUE.SEARCH_BY_NAME };
};





export const venueRequestForBooking = async (data ) => {
  const { url, method  } = ApiConfig.VENUE.BOOKING_REQUEST;
  const response = await apiInstance({
    url: url, 
    method,
    data
  });
   return { response, entity: STATE_ENTITIES.VENUE.BOOKING_REQUEST };
};


export const venueRequestForBiding = async (data ) => {
  const { url, method  } = ApiConfig.VENUE.BIDING_REQUEST;
  const response = await apiInstance({
    url: url, 
    method,
    data
  });
   return { response, entity: STATE_ENTITIES.VENUE.BIDING_REQUEST };
};